<form (ngSubmit)="createReply()" [formGroup]="replyForm" class="d-flex">
    <div class="w-100">
        <input type="text" formControlName="observations" placeholder="Responder..." [class.error]="invalidField('observations')">
        <p *ngIf="invalidField('observations')" class="error-text">Campo obligatorio</p>
    </div>
    <button type="submit" class="ml-05 btn-none send"><img src="/assets/img/intern/icons/menus/send.svg" alt="options" class="icon sm"></button>
</form>